import { Link } from "react-router-dom";
import { Maximize2, Users } from "lucide-react";
import { inr } from "@/lib/format";

export default function RoomCard({ room, propertySlug, fallbackImage }) {
  const img = room.image || fallbackImage;
  return (
    <article data-testid={`room-card-${room.slug}`} className="group bg-white border border-[#E2DCD0] flex flex-col">
      {img && (
        <div className="relative aspect-[4/3] overflow-hidden bg-[#E5D9C5]">
          <img src={img} alt={`${room.name}${room.image_note ? ` - ${room.image_note}` : ""}`} loading="lazy" className="img-zoom h-full w-full object-cover" />
          {(room.image_note || !room.image) && <span className="absolute bottom-2 left-2 bg-black/50 text-white text-[10px] tracking-wider uppercase px-2 py-1">{room.image_note || "Property photo"}</span>}
        </div>
      )}
      <div className="p-6 flex flex-col flex-1">
        <h3 className="text-[26px] sm:text-[30px] font-bold text-[#1E3B2E] leading-tight" data-testid={`room-name-${room.slug}`}>{room.name}</h3>
        <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1 text-xs text-[#6b6b6b]">
          {room.size && <span className="flex items-center gap-1.5"><Maximize2 size={12} />{room.size}</span>}
          <span className="flex items-center gap-1.5"><Users size={12} />Up to {room.capacity} guests</span>
        </div>
        {room.features?.length > 0 && <p className="mt-3 text-sm text-[#3b3b3b]">{room.features.join(" · ")}</p>}
        {room.description && <p className="mt-2 text-sm text-[#6b6b6b] leading-6">{room.description}</p>}
        <div className="flex-1" />
        <div className="mt-6 pt-5 border-t border-[#E2DCD0] flex items-end justify-between gap-3">
          {room.price ? (
            <div data-testid={`room-price-${room.slug}`}>
              <p className="text-[10px] uppercase tracking-[0.2em] text-[#6b6b6b]">From / night</p>
              <p className="font-['Cormorant_Garamond'] text-3xl font-bold text-[#1A1A1A] leading-none mt-1">{inr(room.price)}</p>
              <p className="text-[11px] text-[#1E3B2E] font-medium mt-1">Incl. GST &amp; breakfast</p>
            </div>
          ) : (
            <div data-testid={`room-price-${room.slug}`}><p className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#1A1A1A] leading-tight">Price on request</p><p className="text-[11px] text-[#6b6b6b] mt-1">Rate confirmed before payment</p></div>
          )}
          <Link to={`/book?property=${propertySlug}&room=${room.slug}`} className="btn-primary !h-10 !px-5" data-testid={`room-book-btn-${room.slug}`}>Book</Link>
        </div>
      </div>
    </article>
  );
}
